export default __webpack_public_path__ + "static/media/TVS KING GS+ ESPECIAL_3.41af2a0c.webp";